var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01467 1.30067e-05C10.1524 0.00385171 12.0933 0.846238 13.5262 2.21566L14.6783 1.06356C15.1661 0.575851 16 0.92127 16 1.61101L16 5.93549C16 6.36307 15.6534 6.70968 15.2258 6.70968L10.9013 6.70968C10.2116 6.70968 9.86615 5.87578 10.3539 5.38804L11.7006 4.04127C10.705 3.10904 9.41673 2.59266 8.04806 2.58085C5.06748 2.55511 2.55506 4.9672 2.58084 8.04672C2.60529 10.968 4.97367 13.4194 7.99999 13.4194C9.32667 13.4194 10.5805 12.9459 11.5687 12.0788C11.7217 11.9446 11.9527 11.9528 12.0967 12.0967L13.3761 13.3761C13.5332 13.5333 13.5255 13.7895 13.3605 13.9385C11.942 15.2198 10.0621 16 7.99999 16C3.58174 16 3.22583e-05 12.4183 2.16696e-10 8.00007C-3.22578e-05 3.58688 3.60148 -0.00789021 8.01467 1.30067e-05Z",
    fill: "#0077C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/RefreshIcon.b50676aa08d2492fa655882ab3250703.svg";
export { ForwardRef as ReactComponent };